export const state = () => ({
    selectTreasurer: {},
    Result:'',
    editTreasurer:{},
})